import Chip, { ChipSizes } from '@lib/components/Chip/Chip';
import ChipWithDropDown from '@lib/components/ChipWithDropDown/ChipWithDropDown';
import Menu, { NavItemTypeEnum } from '@lib/components/Menu/Menu';
import { Task, TaskStatusEnum } from 'graphql-common';
import { useTranslation } from 'react-i18next';
import { getTaskStatusChipType, getTaskStatusOptions } from '@lib/utils/status';

type Props = {
  onStatusChangeHandler?: (id: string, v: TaskStatusEnum) => void;
  task: Task;
};

const DROPDOWN_STATUSES = new Set([
  TaskStatusEnum.Validated,
  TaskStatusEnum.OnValidation,
  TaskStatusEnum.Rejected,
]);

export default function TaskStatusChip(props: Props) {
  const { onStatusChangeHandler, task } = props;
  const { id, status } = task;
  const { t } = useTranslation();
  const options = getTaskStatusOptions();
  const label = options.find(({ value }) => value === status)?.labelKey ?? '-';
  const type = getTaskStatusChipType(status);
  if (onStatusChangeHandler !== undefined) {
    const chipLeftIcon = (statusItem: TaskStatusEnum) => (
      <Chip
        leftIcon="circle"
        type={getTaskStatusChipType(statusItem)}
        size={ChipSizes.smallLeftIconOnly}
      />
    );
    const getBody = () => (
      <Menu
        navItems={options
          .filter(
            ({ value }) => DROPDOWN_STATUSES.has(value) && value !== status,
          )
          .map(({ value, labelKey }) => ({
            id: value,
            title: t(labelKey),
            onClick: () => onStatusChangeHandler(id, value),
            type: NavItemTypeEnum.Secondary,
            leftIcon: () => chipLeftIcon(value),
          }))}
      />
    );
    return (
      <div>
        <ChipWithDropDown
          label={t(label)}
          type={type}
          leftIcon="circle"
          width={160}
          body={getBody}
        />
      </div>
    );
  }
  return <Chip type={type} label={t(label)} leftIcon="circle" />;
}
